<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .experience-item {
    display: flex;
    flex-direction: column;
    padding: 0 utils.in_rem(8px);
    width: 100%;
    max-width: 100%;

    .role-company {
      @include mixins.h4();
      @include colors.color(textBlack);
      word-wrap: break-word;
      overflow-wrap: break-word;

      a {
        @include colors.color(primary_50);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .duration {
      @include mixins.body2();
      @include colors.color(textGrey);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .location {
      @include mixins.body2();
      @include colors.color(textLighterBlack);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .description {
      @include mixins.body2();
      @include colors.color(textLighterBlack);
      margin-top: utils.in_rem(2px);
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }
</style>

<script>
  import { formatDate } from "./utils.js";

  export let experience;

  $: startDate = formatDate(experience.startedAt);
  $: endDate = formatDate(experience.endedAt, "Present");

  $: duration = startDate && endDate ? `${startDate} - ${endDate}` : "";

  // Format role and company as "[Role] at [Company]"
  $: roleCompanyText = `${experience.role || "Unknown Role"} at ${experience.company || "Unknown Company"}`;

  // LinkedIn URL formatting
  $: linkedinUrl = experience.companyLinkedinUrl
    ? `https://${experience.companyLinkedinUrl}`
    : null;
</script>

<div class="experience-item">
  <div class="role-company">
    {#if linkedinUrl}
      <a href={linkedinUrl} target="_blank">{roleCompanyText}</a>
    {:else}
      {roleCompanyText}
    {/if}
  </div>

  {#if duration}
    <div class="duration">{duration}</div>
  {/if}

  {#if experience.location}
    <div class="location">{experience.location}</div>
  {/if}

  {#if experience.description}
    <div class="description">{experience.description}</div>
  {/if}
</div>
